<!--
Author: XiangChenyu
Date: 2019-11-14
Desc: 汇款信息页面
 -->
<template>
    <div :class="'view-remit-info view ' + className">
        <comp-title :title="title" />
        <div v-if="info == ''" class="no-data">
            暂无数据
        </div>
        <el-row v-else class="remit-info" :gutter="30">
            <el-col v-for="(item,index) in info" :key="index" :span="24">
                <el-row class="remit-row bg-white">
                    <el-col class="bank-msg" :span="11">
                        <div class="bank-img">
                            <img :src="$util.getImg(item.bankid)" alt="">
                        </div>
                        <div class="bank-main">
                            <span class="bank-b">{{ $cache.getDict('150003',item.bankid) }}</span>
                            <span class="bank-b">{{ item.acct_no }}</span>
                            <span class="">{{ item.issuring_bank }}</span>
                        </div>
                    </el-col>
                    <el-col class="bank-msg-form" :span="13">
                        <el-form
                            ref="info"
                            label-width="180px"
                            :model="item"
                        >
                            <el-col :span="24">
                                <el-form-item label="名称：" prop="acct_name" class="form-text">
                                    <div class="text-con name">
                                        {{ item.acct_name }}
                                    </div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="联行行号：" prop="cnaps">
                                    <div class="text-con">
                                        {{ item.cnaps.trim() ? item.cnaps : "--" }}(异地汇款使用)
                                    </div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="交换号：" prop="bank_exchange_no">
                                    <div class="text-con">
                                        {{ item.bank_exchange_no.trim() ? item.bank_exchange_no : "--" }}(同城交换使用)
                                    </div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="大额支付系统号：" prop="big_cnaps">
                                    <div class="text-con">
                                        {{ item.big_cnaps.trim() ? item.big_cnaps : "--" }}
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-form>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import format from "date-fns/format";

import mixin from "@/assets/js/mixin";
export default {
    name: "Remitinfo",
    mixins: [mixin],
    data () {
        return {
            playSwitch: false,
            info: []
        };
    },
    created () {
        this.getinfo();
    },
    methods: {
        getinfo(){
            //获取信息
            this.$util.request("umpf/remittance",{status: "3"},"GET").then(res=>{
                if(res.data){
                    this.info = res.data;
                }else {
                    this.$message.error(res.msg);
                }
            });
        }
    }
};
</script>
<style lang="scss">
    .view-remit-info {
        overflow: hidden;
        .el-card__body {
            height: 200px;
        }
        .el-form-item {
            margin-bottom: 0px;
        }
        .no-data {
            padding: 20px 0 20px 0;
            text-align: center
        }
        .remit-info{
            padding: 30px;
            .remit-row {
                border: 1px solid #cccccc;
                background: white;
                border-radius: 5px;
                margin-bottom: 30px;
                padding: 20px;
                min-height: 180px;
                height: auto;
                .bank-msg{
                    margin-top: 10px;
                    .bank-img{
                        width: 20%;
                        display: inline-block;
                        vertical-align: middle;
                        text-align: left;
                        border-radius: 100px;
                        box-sizing: border-box;
                        background-color:white;
                        img {
                            width: 80px;
                        }
                    }
                    .bank-main{
                        width: 80%;
                        display: inline-block;
                        vertical-align: middle;
                        .bank-b{
                            font-size: 24px;
                            color: #333333;
                        }
                        span{
                            margin: 10px 0px;
                            display: block;
                            font-size: 16px;
                            color: #666666;
                        }
                    }

                }
                .bank-msg-form{
                    margin-top: -10px;
                    padding-top: 0px;
                    color: #333333;
                    font-size: 16px;
                    border-left: 1px solid #cccccc;
                    .text-con{
                        font-size: 16px;
                        &.name{line-height: 20px;padding: 10px 0;}
                    }
                    .el-form-item__label{
                        font-size: 16px;
                        color: #666666;
                    }
                }
            }
        }
    }
</style>
